import React from "react";
import { KEYWORDS } from "../homeV2.constants";
import useKeywordRotator from "../hooks/useKeywordRotator";
import Reveal from "./Reveal";

const TalentMore = () => {
  const activeIndex = useKeywordRotator(KEYWORDS.length);

  return (
    <section className="hv2-talent-more" id="talent-more">
      <div className="home-v2__container">
        <Reveal as="h2" className="home-v2__h2">
          Talent is more than a <span className="home-v2__highlight">resume</span>
        </Reveal>
        <Reveal as="p" delay={0.08} className="home-v2__body-lg hv2-talent-more__sub">
          employHER gives people a place to show their experience, personality and potential while
          helping employers discover talent they may otherwise miss.
        </Reveal>
        <Reveal delay={0.16} className="hv2-talent-more__keywords">
          {KEYWORDS.map((kw, index) => (
            <span key={kw} className={`hv2-talent-more__kw ${index === activeIndex ? "hv2-talent-more__kw--active" : ""}`}>
              {kw}
            </span>
          ))}
        </Reveal>
      </div>
    </section>
  );
};

export default TalentMore;
